function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component, createElement } from 'react';

var defaultRenderer = function defaultRenderer(row, rowClassName, cellClassName, tagType) {
  return React.createElement("tr", {
    className: rowClassName
  }, row.map(function (col) {
    return createElement(tagType, {
      className: cellClassName,
      key: col
    }, col);
  }));
};

var defaultRowRenderer = function defaultRowRenderer(rows, rowClassName, cellClassName, cellRenderer, onRowClick) {
  return rows.map(function (row) {
    return React.createElement("tr", {
      key: row.id,
      className: rowClassName,
      onClick: onRowClick(row.id)
    }, row.cols.map(function (col, i) {
      return React.createElement("td", {
        key: i,
        className: cellClassName
      }, cellRenderer(col, i, row));
    }));
  });
};

var ClickableTable =
/*#__PURE__*/
function (_Component) {
  _inherits(ClickableTable, _Component);

  function ClickableTable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ClickableTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ClickableTable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleRowClick", function (id) {
      return function (event) {
        _this.props.onRowClick(id, event);
      };
    });

    return _this;
  }

  _createClass(ClickableTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          header = _this$props.header,
          headerClassName = _this$props.headerClassName,
          headerCellClassName = _this$props.headerCellClassName,
          headerRenderer = _this$props.headerRenderer,
          rows = _this$props.rows,
          rowClassName = _this$props.rowClassName,
          cellRenderer = _this$props.cellRenderer,
          cellClassName = _this$props.cellClassName,
          tableHeading = _this$props.tableHeading,
          tableClassName = _this$props.tableClassName,
          footer = _this$props.footer,
          footerClassName = _this$props.footerClassName,
          footerCellClassName = _this$props.footerCellClassName,
          footerRenderer = _this$props.footerRenderer,
          rowRenderer = _this$props.rowRenderer;
      return React.createElement("table", {
        className: tableClassName
      }, header && React.createElement("thead", null, tableHeading && React.createElement("tr", {
        className: headerClassName
      }, React.createElement("th", {
        colSpan: header.length,
        className: headerCellClassName
      }, tableHeading)), headerRenderer(header, headerClassName, headerCellClassName, 'th')), React.createElement("tbody", null, rowRenderer(rows, rowClassName, cellClassName, cellRenderer, this.handleRowClick)), footer && React.createElement("tfoot", null, footerRenderer(footer, footerClassName, footerCellClassName, 'td')));
    }
  }]);

  return ClickableTable;
}(Component);

_defineProperty(ClickableTable, "propTypes", {
  header: PropTypes.array,
  tableHeading: PropTypes.string,
  headerClassName: PropTypes.string,
  headerCellClassName: PropTypes.string,
  footer: PropTypes.array,
  footerRenderer: PropTypes.func,
  headerRenderer: PropTypes.func,
  footerClassName: PropTypes.string,
  footerCellClassName: PropTypes.string,
  rows: PropTypes.array,
  cellRenderer: PropTypes.func,
  rowRenderer: PropTypes.func,
  onRowClick: PropTypes.func,
  tableClassName: PropTypes.string,
  cellClassName: PropTypes.string,
  rowClassName: PropTypes.string
});

_defineProperty(ClickableTable, "defaultProps", {
  tableHeading: null,
  header: null,
  footer: null,
  cellRenderer: function cellRenderer(col) {
    return col;
  },
  footerRenderer: defaultRenderer,
  headerRenderer: defaultRenderer,
  rowRenderer: defaultRowRenderer
});

export default ClickableTable;